<template>
 <img alt="xiaoyanyun" class="zui-logo" :src="src"/>
</template>
<script>
  import './less/logo.less'
  import logo from './img/logo.png'
  export default {
    name: 'Logo',
    props: {
      type: {
        default: 'yuexinyun'
      },
      href: {
        default: '/'
      }
    },
    computed: {
      src: function () {
        if (this.type === 'yuexinyun') {
          return logo
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Logo.vue